import { Theme } from "@mui/material";
import {
  conceptIDs,
  formActionButtonTypes,
  stepTypes,
} from "../../../../constants/constant";
import { SchedulerConfig, Step } from "../../../../Interface/scheduler/form";

const { SUBMIT, BACK, SKIP, BACK_WITH_LESS_THAN_ARROW_ICON, CONTACT_ME } =
  formActionButtonTypes;
const DEFAULT_BUTTON_LAYOUT = [CONTACT_ME, SUBMIT, BACK, SKIP];
const buttonLayouts = {
  default: {
    desktop: DEFAULT_BUTTON_LAYOUT,
    mobile: DEFAULT_BUTTON_LAYOUT,
  },
  [conceptIDs.WDG_CONCEPT_ID]: {
    desktop: {
      default: DEFAULT_BUTTON_LAYOUT,
      [stepTypes.STEP_PRICE_QUOTE_ESTIMATION]: [
        BACK_WITH_LESS_THAN_ARROW_ICON,
        SKIP,
      ],
    },
    mobile: {
      default: DEFAULT_BUTTON_LAYOUT,
      [stepTypes.STEP_PRICE_QUOTE_ESTIMATION]: [BACK, SKIP],
    },
  },
};
export const getButtonLayout = (
  isMobile: boolean,
  formConfig: SchedulerConfig,
  currentStep: number,
  conceptId: string,
  isPriceQuoteCardVisible: boolean
) => {
  const stepType = formConfig.steps[currentStep]?.steptype;
  const conceptLayouts =
    isPriceQuoteCardVisible &&
    stepType === stepTypes.STEP_PRICE_QUOTE_ESTIMATION
      ? buttonLayouts.default
      : buttonLayouts[conceptId] || buttonLayouts.default;

  const deviceLayout = isMobile
    ? conceptLayouts.mobile
    : conceptLayouts.desktop;

  if (typeof deviceLayout === "object" && "default" in deviceLayout) {
    return deviceLayout[stepType] || deviceLayout.default;
  }
  return deviceLayout;
};

export const getButtonStyles = (
  theme: Theme,
  conceptId: string,
  currentStep: number,
  steps: Step[],
  isPriceQuoteCardVisible: boolean
) => {
  const stepType = steps[currentStep]?.steptype;

  if (
    conceptId === conceptIDs.WDG_CONCEPT_ID &&
    stepType === stepTypes.STEP_PRICE_QUOTE_ESTIMATION &&
    !isPriceQuoteCardVisible
  ) {
    return {
      submit: {},
      back: { color: theme.palette.primary.dark, paddingTop: "8px !important" },
      skip: { color: theme.palette.primary.dark, textDecoration: "underline" },
      greaterThanArrowIcon: {
        color: theme.typography.body1.arrowIconColor,
        "&:hover": {
          color: theme.typography.body1.arrowIconColor,
        },
      },
    };
  } else if (conceptId === conceptIDs.WDG_CONCEPT_ID) {
    return {
      submit: {},
      back: { color: theme.palette.primary.dark },
      skip: { color: theme.palette.primary.main },
      greaterThanArrowIcon: {
        color: theme.palette.secondary.light,
        "&:hover": {
          color: theme.palette.secondary.light,
        },
      },
    };
  }
  if (conceptId === conceptIDs.DVW_CONCEPT_ID) {
    return {
      submit: { border: `2px solid ${theme.palette.secondary.main}` },
      back: { color: theme.palette.primary.dark },
      skip: { color: theme.palette.primary.main },
      greaterThanArrowIcon: {
        color: theme.typography.body1.arrowIconColor,
        "&:hover": {
          color: theme.typography.body1.arrowIconColor,
        },
      },
    };
  }
  if (conceptId === conceptIDs.FSP_CONCEPT_ID) {
    return {
      submit: {},
      back: { color: theme.typography.body1.fspLinks },
      skip: { color: theme.palette.primary.main },
      greaterThanArrowIcon: {
        color: theme.typography.body1.arrowIconColor,
        "&:hover": {
          color: theme.typography.body1.arrowIconColor,
        },
      },
    };
  }
  return {
    submit: {},
    back: { color: theme.palette.primary.dark },
    skip: { color: theme.palette.primary.main },
    greaterThanArrowIcon: {
      color: theme.typography.body1.arrowIconColor,
      "&:hover": {
        color: theme.typography.body1.arrowIconColor,
      },
    },
    contactMe: {},
  };
};
